<template>
    <div ref="modal" class="modal" tabindex="-1" role="dialog" @hidden="hidden" id="newIns">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title text-center"> <b> {{title}} </b> </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body text-center">

                <form class="form-horizontal">
                    <div class="form-group">
                        <label for="inputEmail3" class="col-sm-2 control-label">Nombre: </label>
                        <div class="col-sm-10"> <input class="form-control input-sm" type="text" v-model.trim="nombre"> </div>
                    </div>

                    <div class="form-group">
                        <label for="inputEmail3" class="col-sm-2 control-label">Abreviatura: </label>
                        <div class="col-sm-10"> <input class="form-control input-sm" type="text" v-model.trim="abreviatura"> </div>
                    </div>

                    <div class="form-group">
                        <label for="inputEmail3" class="col-sm-2 control-label">Tipo: </label>
                        <div class="col-sm-10">
                          <select class="form-control input-sm" v-model="tipo">
                            <option value="U">Universidad</option>
                            <option value="I">Institucion</option>
                          </select>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="inputEmail3" class="col-sm-2 control-label">Convenio: </label>
                        <div class="col-sm-10">
                          <select class="form-control input-sm" v-model="convenio">
                            <option value="true">Si</option>
                            <option value="false">No</option>
                          </select>
                        </div>
                    </div>
                </form>

                <p class="text-center text-danger"> {{msg}} </p>
            </div>
            
            <Alertas ref="alertar" />
            <div class="modal-footer">
                <button @click="submit" v-if="activo" type="button" class="btn btn-azul">Guardar</button>
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import Alertas from '@/components/AAlertas.vue'
import gql from 'graphql-tag'

    export default {
        props:{edit:{type:Object,required:false}},
        data(){
            return{
                activo: true,
                msg: null,
                nombre: null,
                abreviatura: null,
                tipo: 'U',
                convenio: false,
                title: '',
            }
        },
        watch:{
        },
        components:{Alertas},
        methods:{
            hidden(){
                this.$refs.alertar.cargando();
            },
            llenar(){
                this.title = 'Registrar Nueva Institucion';
                if( !this.edit || !this.edit.id ) return;
                this.title = 'Editar Institucion';
                this.nombre = this.edit.nombre;
                this.abreviatura = this.edit.abreviatura;
                this.tipo = this.edit.tipo;
                this.convenio = this.edit.convenio;
            },
            submit(){
                this.msg = null;
                if( !this.validar() ){
                  return;
                }
                if( this.edit && this.edit.id ){
                    this.actualizar();
                    return;
                }
                var sql = gql`mutation{ createInstitucion(input:{nombre:"${this.nombre}",tipo:"${this.tipo}",convenio:${this.convenio},abreviatura:"${this.abreviatura}"}){ok,errors{message}} }`;
                var vue = this;
                vue.$refs.alertar.cargando('Registrando...');
                vue.activo = false;
                this.$apollo.mutate({mutation: sql})
                .then((data) => {
                  if( data.data.createInstitucion){
                    vue.$refs.alertar.success('Registrado');
                    this.$emit('exito');
                  }else{
                    var errores = JSON.stringify(data.data.createInstitucion.errors);
                    var obj = JSON.parse(errores);
                    var vals = "Error Desconocido";
                    if( obj != null ) obj.forEach(function(k) { vals += Object.values(k) + "-\n\t"; });
                    vue.msg = vals;
                    vue.activo = true;
                  }
                 
                }).catch((error) => {
                    window.console.error(error);
                    vue.$refs.alertar.invalido();
                })
            },
            actualizar(){
                this.msg = null;
                var sql = gql`mutation{ updateInstitucion(input:{id:${this.edit.id},nombre:"${this.nombre}",tipo:"${this.tipo}",convenio:${this.convenio},abreviatura:"${this.abreviatura}"}){ok,errors{message}} }`;
                var vue = this;
                vue.$refs.alertar.cargando('Actualizando...');
                vue.activo = false;
                window.console.log( sql );
                this.$apollo.mutate({mutation: sql})
                .then((data) => {
                  if( data.data.updateInstitucion){
                    vue.$refs.alertar.success('Actualizado');
                    this.$emit('exito');
                  }else{
                    var errores = JSON.stringify(data.data.updateInstitucion.errors);
                    var obj = JSON.parse(errores);
                    var vals = "Error Desconocido";
                    if( obj != null ) obj.forEach(function(k) { vals += Object.values(k) + "-\n\t"; });
                    vue.msg = vals;
                  }
                    vue.activo = true;
                 
                }).catch((error) => {
                    window.console.error(error);
                    vue.$refs.alertar.invalido();
                    vue.activo = true;
                })
            },
            validar(){
                var valido = true;
                if( !this.nombre ) { this.msg = 'Falta el nombre'; valido = false }
                else if( !this.abreviatura ) { this.msg = 'Falta la abreviatura'; valido = false }
                if( this.convenio == 'true' ) this.convenio = true;
                else this.convenio = false;
                return valido;
            }
        },
        mounted(){
            const vue = this;
            window.$('#newIns').on('shown.bs.modal',function(){ 
                vue.llenar();
            });
            window.$('#newIns').on('hidden.bs.modal',function(){ 
                vue.nombre = null;
                vue.abreviatura = null;
                vue.tipo = 'U';
                vue.convenio = false;
                vue.$refs.alertar.reset();
                window.console.log( '----' );
            });
        }
    }
</script>